/**
 * @file Renders the Console manager's sidebar and page outlet, with the list of organizations.
 */
import { Outlet } from "react-router-dom";
import { Layout, theme } from "antd";

import { SIDEBAR_WIDTH } from "@components/Constants";
import { useOrganizations } from "@components/Organization";
import { useLayoutTopOffset, ReleaseAlert } from "@components/Page";

import Sidebar from "./Sidebar";
import { MANAGER_MENU_ITEMS } from "./Sidebar/helpers/menuItems";
import { SecondFactorAlert } from "../../backstage/index.js";


/**
 * Renders the manager sidebar, alerts and current page, with the organizations in context.
 */
const ConsoleManagerLayout = () => {
  const { token } = theme.useToken();
  const { colorBgContainer } = token;

  const organizations = useOrganizations();
  const layoutTopOffset = useLayoutTopOffset();

  const layoutProps = {
    style: {
      marginLeft: SIDEBAR_WIDTH,
      background: colorBgContainer,
    },
  };

  const context = {
    organizations,
    layoutTopOffset,
  };

  return (
    <>
      <Sidebar items={MANAGER_MENU_ITEMS} />

      <Layout {...layoutProps}>
        <ReleaseAlert />
        <SecondFactorAlert />

        <Layout.Content>
          <Outlet context={context} />
        </Layout.Content>
      </Layout>
    </>
  );
};

export default ConsoleManagerLayout;
